import { module } from './store'
import { initCacheStorage } from '@vue-storefront/core/helpers/initCacheStorage'
import { beforeEach } from './router/beforeEach'

export const KEY = 'url'
export const cacheStorage = initCacheStorage(KEY)

export const UrlExtend = {
  key: KEY,
  store: { modules: [{ key: KEY, module: module }] },
  router: { beforeEach }
}
